<template>
  <v-layout wrap>
    <v-flex xs5 md4>
      <!-- <div class="form-control">
        <multiselect
          v-model="caseA"
          :options="filterVariable"
          :searchable="true"
          track-by="name"
          label="name"
          @input="onChangeCaseA"
        ></multiselect>
      </div> -->
      <v-autocomplete
        class="variable"
        v-model="caseA"
        return-object
        :items="filterVariable"
        :filter="customFilter"
        item-text="name"
        single-line
        outline
        @input="onChangeCaseA"
      ></v-autocomplete>
    </v-flex>
    <v-flex xs1 class="text-xs-center">
      <v-icon class="mt-2">arrow_back</v-icon>
    </v-flex>
    <v-flex xs6 md4 class="form-control">
      <div
        class="form-control"
        :class="{ 'has-error': errors.has('caseB') }"
        v-if="caseA != '' && caseA != null"
      >
        <dynamic-update-variable
          :key="caseA.value"
          v-model="caseB"
          :datatype="caseA.value"
          @onChange="onChangeCaseB"
        ></dynamic-update-variable>

        <input
          name="caseB"
          type="hidden"
          v-model="caseB"
          data-vv-as="Case B"
          v-validate="'required'"
        />
      </div>
    </v-flex>
    <v-flex xs6 md2 class="text-xs-left">
      <v-checkbox
        color="primary"
        :value="istransaction"
        @change="onChangeTransaction"
        :label="`Transaction`"
        class="mt-2"
      ></v-checkbox>
    </v-flex>
    <v-flex xs6 md1 class="text-xs-right text-md-left">
      <v-btn outline fab small color="primary" @click="$emit('onDelete')">
        <v-icon>delete</v-icon>
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import Multiselect from 'vue-multiselect'
import DynamicUpdateVariable from './DynamicUpdateVariable'
import { mapGetters, mapMutations } from 'vuex'
export default {
  props: ['value'],
  inject: ['$validator'],
  data() {
    return {
      caseA: '',
      caseB: '',
      isFoundCaseA: true,
      istransaction: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      flows: 'getFlowList',
      loadingFlowList: 'getLoadingFlowList',
      variable: 'getVariableList',
      loadingVariableList: 'getLoadingVariableList',
      selectedFlow: 'getFlowId'
    }),
    filterVariable() {
      var vm = this
      var variable = []
      if (vm.variable) {
        variable = vm.variable.filter(el => {
          return el.flowid == 0 || (vm.selectedFlow && el.flowid == vm.selectedFlow.id)
        })
      }
      var result = []
      variable.map(el => {
        result.push({
          name: el.name,
          value: el.name
        })
      })
      return result
    }
  },
  components: {
    Multiselect,
    DynamicUpdateVariable
  },
  mounted() {
    if (this.value) {
      var caseA = this.filterVariable.find(el => {
        return el.name == this.value.name
      })
      this.caseA = caseA ? caseA : null
      this.isFoundCaseA = !(this.caseA == null && this.value.name != '' && this.value.name != null)
      this.caseB = this.value.value
      this.istransaction = this.value.istransaction
    } else {
      this.caseA =
        this.filterVariable && this.filterVariable.length > 0 ? this.filterVariable[0] : null
    }
  },
  methods: {
    customFilter(item, queryText, itemText) {
      const textOne = item.name.toLowerCase()
      const textTwo = item.value.toLowerCase()
      const searchText = queryText.toLowerCase()

      return textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
    },

    onChangeCaseA(val) {
      var caseB = ''
      if (this.caseB && typeof this.caseB == 'string') {
        caseB = this.caseB.trim()
      } else if (this.caseB && typeof this.caseB == 'object') {
        caseB = `{${this.caseB.value}}`
      }
      var data = {
        name: `${this.caseA.name}`,
        value: caseB,
        istransaction: this.istransaction
      }
      this.$emit('input', data)
    },
    onChangeCaseB() {
      var caseB = ''
      if (this.caseB && typeof this.caseB == 'string') {
        caseB = this.caseB.trim()
      } else if (this.caseB && typeof this.caseB == 'object') {
        caseB = `{${this.caseB.value}}`
      }
      var data = {
        name: `${this.caseA.name}`,
        value: caseB,
        istransaction: this.istransaction
      }
      this.$emit('input', data)
    },
    onChangeTransaction(val) {
      this.istransaction = val
      var caseB = ''
      if (this.caseB && typeof this.caseB == 'string') {
        caseB = this.caseB.trim()
      } else if (this.caseB && typeof this.caseB == 'object') {
        caseB = `{${this.caseB.value}}`
      }
      var data = {
        name: `${this.caseA.name}`,
        value: caseB,
        istransaction: this.istransaction
      }
      this.$emit('input', data)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/flow/AddEditVariable.vue